const stickyHeader = () => {
	const header = document.querySelector('[data-sticky-header]');
	if (!header) return;
	const update = () => header.classList.toggle('is-stuck', window.scrollY > 80);
	update();
	window.addEventListener('scroll', update, { passive: true });
};
export default stickyHeader;
